/// <amd-module name="Artifacts/Pypi/commands/Delete" />
import { PypiActions } from "Artifacts/Pypi/redux";
import { getDeleteCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createDeleteCommand = getDeleteCommandCreator(PypiActions.softDelete);
